import { render } from "./DotCloud.vue?vue&type=template&id=3f542612&scoped=true"
import script from "./DotCloud.vue?vue&type=script&lang=js"
export * from "./DotCloud.vue?vue&type=script&lang=js"

import "./DotCloud.vue?vue&type=style&index=0&id=3f542612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f542612"]])

export default __exports__